import React from "react";
import "./LoadingModal.css";

const LoadingModal = () => {
  return (
    <div className="loading-modal">
      <div className="loading-spinner"></div>
      <div className="loading-text"></div>
    </div>
  );
};

export default LoadingModal;
